import { Component, Input, OnInit } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DATE_MMYYYY_FORMATS } from '../../cpos-modules/admin/loyalty-discount-configuration/loyalty-discount-configuration.component';
import { DateService } from '../../common-services/common-functions.service';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.css'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],},
      { provide: MAT_DATE_FORMATS, useValue: DATE_MMYYYY_FORMATS },]
})
export class DynamicTableComponent implements OnInit {
  @Input() caption: string = "";
  @Input() columnHeader: string[] = []; // Column names passed from the parent for display Purpose
  @Input() columns: string[] = [];  // Column names passed from the parent
  @Input() data: any[] = [];  // Data passed from the parent
  @Input() uploadedFile: string;
  uploadedDateTime: string;
  @Input() uploadedUserName: string;
  @Input() totalRecordCount: number;
  @Input() successRecordCount: number;
  @Input() failureRecordCount: number;
  @Input() failureRecord: string;

  constructor() {
    this.uploadedDateTime = DateService.formatDate(String(new Date()),'DD-MM-YYYY hh:mm:ss a');
  }

  ngOnInit(): void {
  }

}
